import { faCheckCircle, faClock, faComments } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { useSelector } from 'react-redux';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import PageHeader from '../../common/PageHeader';
import { buildSupportWhatsAppUrl } from '../../../helpers/supportWhatsapp';

const WHATSAPP_MESSAGE = 'Hola equipo Homelan, necesito ayuda con mi cuenta.';
const WHATSAPP_HREF = buildSupportWhatsAppUrl(WHATSAPP_MESSAGE);

const Support = () => {

    const { role } = useSelector(state => state.auth.user);

    return <>
        <PageHeader
            title="Soporte" titleTag="h2"
            description={role === 'manager' ? 'Contacta con nuestro equipo de soporte para resolver tus inconvenientes de forma directa y cercana.' : 'Canal directo de atención para resolver los inconvenientes de los usuarios de Homelan.'}
            className="mb-3" col={{ lg: 9 }}
        />
        <Card className="border-0 shadow-sm overflow-hidden">
            <CardBody className="p-0">
                <Row noGutters className="align-items-stretch">
                    <Col lg={7} className="p-4 p-md-5">
                        <div className="d-flex align-items-center mb-4">
                            <div
                                className="d-flex align-items-center justify-content-center text-white mr-3"
                                style={{ width: 56, height: 56, borderRadius: 12, backgroundColor: '#25D366' }}
                            >
                                <FontAwesomeIcon icon={faWhatsapp} size="2x" />
                            </div>
                            <div>
                                <h4 className="mb-1">Hablemos por WhatsApp</h4>
                                <p className="text-muted mb-0">Atención directa con el equipo de Homelan.</p>
                            </div>
                        </div>

                        <h2 className="font-weight-bold mb-3">Cuéntanos qué necesitas y te acompañamos.</h2>
                        <p className="text-700 fs-0 mb-4">
                            Recibe orientación de una forma rápida, humana y sencilla. Escríbenos y comparte tu caso con nuestro equipo.
                        </p>

                        <Button
                            tag="a"
                            href={WHATSAPP_HREF}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white font-weight-bold px-4 py-2 d-inline-flex align-items-center"
                            style={{ backgroundColor: '#25D366', borderColor: '#25D366', borderRadius: 8 }}
                        >
                            <FontAwesomeIcon icon={faWhatsapp} className="mr-2" size="lg" />
                            Ir a WhatsApp
                        </Button>
                    </Col>

                    <Col lg={5} className="bg-light p-4 p-md-5 d-flex align-items-center">
                        <div className="w-100">
                            <div className="d-flex mb-4">
                                <FontAwesomeIcon icon={faComments} className="text-primary fs-2 mr-3 mt-1" />
                                <div>
                                    <h5 className="mb-1">Contacto conversacional</h5>
                                    <p className="text-muted mb-0">Comparte detalles, capturas o dudas en una conversación fluida.</p>
                                </div>
                            </div>
                            <div className="d-flex mb-4">
                                <FontAwesomeIcon icon={faClock} className="text-primary fs-2 mr-3 mt-1" />
                                <div>
                                    <h5 className="mb-1">Respuesta más ágil</h5>
                                    <p className="text-muted mb-0">El equipo recibe tu mensaje en el canal donde podemos orientarte mejor.</p>
                                </div>
                            </div>
                            <div className="d-flex">
                                <FontAwesomeIcon icon={faCheckCircle} className="text-primary fs-2 mr-3 mt-1" />
                                <div>
                                    <h5 className="mb-1">Seguimiento cercano</h5>
                                    <p className="text-muted mb-0">Mantén la conversación abierta hasta resolver tu solicitud.</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    </>
}

export default Support;